import { render, staticRenderFns } from "./MiniButton.vue?vue&type=template&id=b606e1d4&"
import script from "./MiniButton.vue?vue&type=script&lang=js&"
export * from "./MiniButton.vue?vue&type=script&lang=js&"
import style0 from "./MiniButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports